import React from 'react';

import { Message, MessageWrapperChooseItem } from './styles';

interface MessageChooseItemProps {
  message?: string;
  children?: React.ReactNode;
}

const MessageChooseContract = ({
  message,
  children
}: MessageChooseItemProps) => {
  return (
    <MessageWrapperChooseItem>
      {message ? <Message>{message}</Message> : null}
      {children}
    </MessageWrapperChooseItem>
  );
};

export default MessageChooseContract;
